(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

;// CONCATENATED MODULE: ./src/images/logo-kenzie.svg
/* harmony default export */ var logo_kenzie = ({"src":"/_next/static/media/logo-kenzie.51427f9d.svg","height":207,"width":206});
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/Footer/styles.ts

var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "styles__StyledFooter",
  componentId: "sc-1aj9gkm-0"
})(["background-color:", ";"], function (_ref) {
  var bgColor = _ref.bgColor;
  return bgColor ? bgColor : "var(--bg)";
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1aj9gkm-1"
})(["padding:2rem 1.5rem 1rem;position:relative;max-width:var(--max-width);@media (min-width:1024px){display:flex;justify-content:space-between;padding:4rem 2.5rem 3rem;margin:auto;}@media (min-width:1580px){padding:4rem 0 3rem;}"]);
var Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styles__Logo",
  componentId: "sc-1aj9gkm-2"
})(["position:absolute;top:2rem;right:1.5rem;object-fit:contain;@media (min-width:1024px){position:initial;width:192px;height:208px;object-position:right;}"]);
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-1aj9gkm-3"
})(["display:flex;flex-direction:column;gap:2rem;&,li,a{color:var(--text-color-secondary);}li{margin-bottom:1.5rem;}a{transition:color 0.3s ease-in-out;&:hover,&:focus{color:var(--highlight-blue);}}@media (min-width:1024px){flex-direction:row;div{flex:1;}}"]);
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1aj9gkm-4"
})(["font-size:1.25rem;font-weight:800;margin-bottom:1.5rem;"]);
var SocialList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__SocialList",
  componentId: "sc-1aj9gkm-5"
})(["column-count:2;width:fit-content;font-size:1rem;a{font-weight:300;}@media (min-width:1024px){column-count:1;}"]);
var ContactList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__ContactList",
  componentId: "sc-1aj9gkm-6"
})(["li{margin:1rem 0;font-weight:300;a{font-weight:400;}}"]);
var Rights = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Rights",
  componentId: "sc-1aj9gkm-7"
})(["font-size:0.875rem;text-align:center;color:#6e6e6e;border-top:1px solid var(--text-color);padding:2rem 1.5rem;display:flex;align-items:center;justify-content:center;flex-direction:column;"]);
var Politics = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Politics",
  componentId: "sc-1aj9gkm-8"
})(["margin:0 auto;display:flex;padding-bottom:1.5rem;a{color:#8e8e8e;font-size:1rem;padding-bottom:0.0125rem;border-bottom:1px solid;}@media (min-width:1024px){justify-content:center;}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx




function Footer(_ref) {
  var bgColor = _ref.bgColor;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFooter, {
    bgColor: bgColor,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
        src: logo_kenzie.src,
        alt: "Kenzie Academy Logo",
        width: "64",
        height: "64"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
            children: "KENZIE NA REDE"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SocialList, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.facebook.com/kenzieacademybr/?utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "Facebook"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.instagram.com/kenzieacademybr/?utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "Instagram"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.youtube.com/channel/UC6rcCbDzhVoIm1V7WnwPDIQ?sub_confirmation=1&utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "YouTube"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.linkedin.com/school/kenzie-academy-brasil/?utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "LinkedIn"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.tiktok.com/@kenzieacademy_br?utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "TikTok"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://twitter.com/kenzieacademybr?utm_campaign=eventos&utm_medium=organico&utm_source=site",
                target: "_blank",
                rel: "noreferrer",
                children: "Twitter"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
            children: "CONTATO"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactList, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "R. General Mario Tourinho, 1733 - 706 - Semin\xE1rio, Curitiba/PR"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Avenida Efig\xEAnio Salles, 1299 - Aleixo, Manaus/AM"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "CNPJ 35.224.825/0001-74"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "mailto:contato@kenzie.com.br",
                rel: "noreferrer",
                children: "contato@kenzie.com.br"
              })
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Rights, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Politics, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://formulario-kenzie.vercel.app/termos-condicoes",
          rel: "noreferrer",
          target: '_blank',
          children: "Pol\xEDtica de Privacidade"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\xA9 2022 Kenzie Academy. All rights reserved."
      })]
    })]
  });
}

/***/ }),

/***/ 1210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(9332);
// EXTERNAL MODULE: ./src/components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(5979);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/images/logo-header.png
/* harmony default export */ var logo_header = ({"src":"/_next/static/media/logo-header.81ef0602.png","height":45,"width":181,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEX///////////////////////////////////8HBRbfAAAACXRSTlNSQzlcXYypdMnWK72iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGPgYGdiZmBgZGBgY2ViYWBmZAAAAdsAK6+vabkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/Header/styles.ts

var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "styles__StyledHeader",
  componentId: "sc-hbxcw1-0"
})(["z-index:10;top:0;left:0;right:0;height:86px;background-color:var(--highlight-blue);transition:background,border 0.3s ease;img{object-fit:contain;@media (min-width:768px){height:45px;width:181px;}}@media (min-width:1024px){height:82px;}"]);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-hbxcw1-1"
})(["max-width:var(--max-width);width:85%;height:100%;margin:0 auto;display:flex;justify-content:center;align-items:center;@media (min-width:360px){width:70%;}@media (min-width:1024px){justify-content:space-between;}@media (min-width:1600px){width:50%;}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Header/index.tsx




function Header() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeader, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        title: "Formul\xE1rio de inscri\xE7\xE3o - Kenzie Academy Brasil",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://kenzie.com.br/",
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: logo_header.src,
            alt: "Logo Kenzie Academy",
            width: "120",
            height: "30",
            unoptimized: true
          })
        })
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/hooks/useCookies.tsx
function getCookie(cookieName) {
  var _document$cookie$spli;

  return (_document$cookie$spli = document.cookie.split('; ').find(function (row) {
    return row.startsWith(cookieName);
  })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.split('=')[1];
}
function setCookie(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _ref$opts = _ref.opts,
      opts = _ref$opts === void 0 ? '' : _ref$opts;
  document.cookie = "".concat(name, "=").concat(value, "; Domain=").concat(".kenzie.com.br", "; SameSite=strict; Secure; ").concat(opts);
}
;// CONCATENATED MODULE: ./src/hooks/useFirstInteractionFields.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var firstInteractionFieldList = ['utm_source_first', 'utm_medium_first', 'utm_campaign_first', 'utm_content_first', 'utm_term_first', 'has_src_first', 'has_cam_first', 'has_grp_first', 'has_ad_first'];
var useFirstInteractionFields = function useFirstInteractionFields() {
  return {
    setFirstInteractionInCookies: function setFirstInteractionInCookies(params) {
      firstInteractionFieldList.forEach(function (field) {
        var cookieValue = getCookie(field);
        var paramValue = params.get(field.replace('_first', ''));
        if (cookieValue === undefined && paramValue !== null) setCookie({
          name: field,
          value: paramValue
        });
      });
    },
    buildFirstInteractionFields: function () {
      var _buildFirstInteractionFields = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", firstInteractionFieldList.map(function (field) {
                  var _getCookie;

                  return (0,defineProperty/* default */.Z)({}, field, (_getCookie = getCookie(field)) !== null && _getCookie !== void 0 ? _getCookie : 'no-tracking');
                }).reduce(function (acc, current) {
                  return _objectSpread(_objectSpread({}, acc), current);
                }, {}));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildFirstInteractionFields() {
        return _buildFirstInteractionFields.apply(this, arguments);
      }

      return buildFirstInteractionFields;
    }()
  };
};
;// CONCATENATED MODULE: ./src/styles/pages/home.ts

var Background = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "home__Background",
  componentId: "sc-11n3kcp-0"
})(["background:linear-gradient(131.31deg,#f5f5f5 3.65%,#92b7fb 100%);"]);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "home__Content",
  componentId: "sc-11n3kcp-1"
})(["max-width:var(--max-width);margin:0 auto;padding:3.5rem 0;width:90%;@media (min-width:360px){width:85%;}@media (min-width:1024px){padding:5rem 0;}"]);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(5496);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(6627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./src/hooks/Contact/index.tsx
var Contact = __webpack_require__(9062);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/styles/global.tsx
var global = __webpack_require__(2614);
;// CONCATENATED MODULE: ./src/components/Input/styles.ts

var StyledInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__StyledInputContainer",
  componentId: "sc-1lgoubd-0"
})(["margin-top:1.5rem;width:100%;label{font-family:'Open Sans',sans-serif;display:block;margin:0.313rem 0 0.313rem 1rem;color:var(--text-color);font-weight:700;font-size:1rem;}input{width:100%;padding:1.25rem 0.625rem;border:1px solid #a49f9f;border-radius:5px;outline:none;color:#909090;font-size:1.2rem;margin-top:0.5rem;background:#fff;&::placeholder{font-size:1.125rem;color:#909090;}&:focus{border:2px solid var(--highlight-blue);}}@media (min-width:1024px){label{font-size:1.125rem;}}"]);
;// CONCATENATED MODULE: ./src/components/Input/index.tsx


var _excluded = ["error", "label", "type", "id"];

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var error = _ref.error,
      label = _ref.label,
      type = _ref.type,
      id = _ref.id,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledInputContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: id,
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", Input_objectSpread({
      id: id,
      type: type,
      ref: ref
    }, rest)), (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,jsx_runtime.jsx)(global/* Error */.jj, {
      children: error.message
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/PersonalData/styles.ts

var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-qi38w9-0"
})(["margin:1.875rem auto;display:flex;flex-direction:column;max-width:24.688rem;@media (min-width:1024px){flex-direction:row;max-width:69.625rem;background:var(--text-color-secondary);margin:2rem auto;border-radius:20px;}"]);
var ProcessDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ProcessDescription",
  componentId: "sc-qi38w9-1"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.25rem;padding:1.875rem;background:var(--highlight-blue);border-radius:20px;h2{font-size:1.375rem;font-weight:800;text-transform:uppercase;text-align:center;color:var(--highlight-yellow);}p{color:var(--text-color-secondary);text-align:center;}@media (min-width:1024px){max-width:32.188rem;padding:2.375rem 4.375rem;h2{text-align:initial;font-size:1.875rem;}p{font-size:1.125rem;text-align:initial;max-width:18.75rem;align-self:flex-start;}}"]);
var StartOfClasses = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__StartOfClasses",
  componentId: "sc-qi38w9-2"
})(["display:flex;flex-direction:column;align-items:center;gap:0.5rem;border-radius:14px;border:1px solid var(--text-color-secondary);width:100%;padding:1.25rem 0.35rem;h3{font-family:'Montserrat',sans-serif;font-size:1.125rem;color:var(--highlight-yellow);text-align:center;}.flex{display:flex;margin:0 auto;gap:1.25rem;div{display:flex;flex-direction:column;align-items:center;gap:0.2rem;p{&.modality{text-align:center;font-weight:700;}&.date{margin:0 auto;}}svg{width:24px;height:24px;}}}@media (min-width:1024px){margin-top:1rem;h3{font-size:1.25rem;}.flex{div{svg{margin-bottom:0.5rem;}p{&.modality{width:100%;text-align:center;}}}}}"]);
var Inputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Inputs",
  componentId: "sc-qi38w9-3"
})(["@media (min-width:1024px){width:100%;padding:1.875rem 2.5rem;}"]);
var PhoneContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PhoneContainer",
  componentId: "sc-qi38w9-4"
})(["min-width:49%;margin-top:1.5rem;label{font-family:'Open Sans',sans-serif;font-size:1rem;display:block;margin:0.313rem 0 0.313rem 1rem;color:var(--text-color);font-weight:700;}input{width:100%;padding:1.22rem 0.625rem;border:1px solid #a49f9f;border-radius:5px;outline:none;color:#909090;font-size:1.2rem;margin-top:0.5rem;background:#fff;font-family:'Open Sans',sans-serif;&::placeholder{font-size:1.125rem;color:#909090;}&:focus{border:2px solid var(--highlight-blue);}}@media (min-width:1024px){label{font-size:1.125rem;}}"]);
var Terms = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Terms",
  componentId: "sc-qi38w9-5"
})(["font-size:0.6rem;font-family:'Open Sans',sans-serif;margin:1.5rem auto 0;align-self:center;a{font-size:0.6rem;text-decoration:underline;}@media (min-width:1024px){font-size:0.8rem;align-self:center;padding:0 0.7rem;a{font-size:0.8rem;}}"]);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./src/components/PersonalData/personalDataSchema.ts
var MANDATORY_FIELD_MESSAGE = 'Campo obrigatório!';

var personalDataSchema = es/* object */.Ry().shape({
  email: es/* string */.Z_().email('E-mail inválido').required(MANDATORY_FIELD_MESSAGE).matches(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/, 'E-mail inválido'),
  first_name: es/* string */.Z_().required(MANDATORY_FIELD_MESSAGE),
  last_name: es/* string */.Z_().required(MANDATORY_FIELD_MESSAGE),
  phone: es/* string */.Z_().required(MANDATORY_FIELD_MESSAGE).matches(/\(\d{2}\)\s\d{4,5}-\d{4}/, {
    message: 'Telefone inválido'
  })
  /* payment_method: yup.string().required(MANDATORY_FIELD_MESSAGE), */

});
;// CONCATENATED MODULE: ./src/utils/dataLayer.js
function pushDataLayer(data) {
  var dataLayer = window.dataLayer || [];
  dataLayer.push(data);
}
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/components/SubmitButton/styles.ts

var StyledSubmitButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__StyledSubmitButton",
  componentId: "sc-1kn1of5-0"
})(["font-family:'JetBrains Mono',sans-serif;font-weight:700;text-transform:uppercase;padding:1rem 1.5rem;border-radius:90px;background:var(--highlight-blue);height:2.813rem;width:12.438rem;display:block;color:#fff;transition:all 0.3s ease-in-out;margin-top:1.5rem;cursor:pointer;margin:1.5rem auto auto;&:hover,&:focus{box-shadow:0 0 16px 4px var(--highlight-blue);}@media (min-width:1024px){height:4.25rem;width:14.25rem;font-size:1.125rem;}"]);
;// CONCATENATED MODULE: ./src/components/PersonalData/index.tsx




function PersonalData_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PersonalData_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PersonalData_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PersonalData_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function PersonalData() {
  var _errors$phone, _errors$phone2;

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useContact = (0,Contact/* useContact */.A)(),
      contact = _useContact.contact;

  var _useFirstInteractionF = useFirstInteractionFields(),
      buildFirstInteractionFields = _useFirstInteractionF.buildFirstInteractionFields;

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup_module/* yupResolver */.X)(personalDataSchema),
    mode: 'onChange'
  }),
      register = _useForm.register,
      errors = _useForm.formState.errors,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues;

  function setPhoneValue() {
    var _contact$phone;

    var phoneInput = document.getElementById('phone');
    phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.setAttribute('value', (_contact$phone = contact.phone) !== null && _contact$phone !== void 0 ? _contact$phone : '');
  }

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }
  /*
  const paymentOptions = [
    {
      label: 'Fullstack - À Vista | R$ 2.997',
      value: 'Fullstack À Vista',
    },
    {
      label: 'Fullstack - Parcelado | 12x de R$ 297',
      value: 'Fullstack Parcelado',
    },
    {
      label: 'Front-end - À Vista | R$ 1.997',
      value: 'Front-end À Vista',
    },
    {
      label: 'Front-end - Parcelado | 12x de R$ 197',
      value: 'Front-end Parcelado',
    },
  ];
  */


  function _onSubmit() {
    _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var firstInteractionFields, newContact, _axiosError$response, axiosError;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              pushDataLayer({
                event: 'form_submit_kenzie',
                form_name: 'Formulário de Inscrição',
                payment_method: 'Fullstack À Vista'
              });
              _context.next = 5;
              return buildFirstInteractionFields();

            case 5:
              firstInteractionFields = _context.sent;
              newContact = PersonalData_objectSpread(PersonalData_objectSpread(PersonalData_objectSpread({}, contact), data), firstInteractionFields);
              _context.next = 9;
              return axios_default().post('/api/subscription', newContact);

            case 9:
              window.location.href = "/completed_subscription?name=".concat(data.first_name);
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              axiosError = _context.t0;
              console.log((_axiosError$response = axiosError.response) === null || _axiosError$response === void 0 ? void 0 : _axiosError$response.data.errors);

            case 16:
              _context.prev = 16;
              setLoading(false);
              return _context.finish(16);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12, 16, 19]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    var _contact$email, _contact$first_name, _contact$last_name, _contact$phone2;

    setValue('email', (_contact$email = contact.email) !== null && _contact$email !== void 0 ? _contact$email : '');
    setValue('first_name', (_contact$first_name = contact.first_name) !== null && _contact$first_name !== void 0 ? _contact$first_name : '');
    setValue('last_name', (_contact$last_name = contact.last_name) !== null && _contact$last_name !== void 0 ? _contact$last_name : '');
    setValue('phone', (_contact$phone2 = contact.phone) !== null && _contact$phone2 !== void 0 ? _contact$phone2 : '');
    setPhoneValue();
  }, []);
  (0,react.useEffect)(function () {
    function handleAbandon() {
      var values = getValues();
      var newDataLayer = {
        event: 'form_submit_kenzie',
        form_name: 'Nome do formulário',
        input_user_name: !!values.first_name,
        input_user_surname: !!values.last_name,
        input_user_email: !!values.email,
        input_user_phone: !!values.phone,
        payment_method: !!values.payment_method
      };
      pushDataLayer(newDataLayer);
    }

    window.addEventListener('beforeunload', handleAbandon);
    return function () {
      window.removeEventListener('beforeunload', handleAbandon);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProcessDescription, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Entre na lista de espera para as pr\xF3ximas turmas!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Voc\xEA est\xE1 dando o primeiro passo para se tornar uma pessoa programadora!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Lembre-se de preencher as informa\xE7\xF5es corretamente."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Inputs, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, PersonalData_objectSpread(PersonalData_objectSpread({
          id: "firstName",
          label: "Nome",
          type: "text",
          placeholder: "Digite aqui o seu nome"
        }, register('first_name')), {}, {
          error: errors.first_name
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, PersonalData_objectSpread(PersonalData_objectSpread({
          id: "lastName",
          label: "Sobrenome",
          type: "text",
          placeholder: "Digite aqui o seu sobrenome"
        }, register('last_name')), {}, {
          error: errors.last_name
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, PersonalData_objectSpread(PersonalData_objectSpread({
          id: "email",
          label: "Email",
          type: "text",
          placeholder: "Digite aqui o seu melhor email"
        }, register('email')), {}, {
          error: errors.email
        })), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhoneContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "phone",
            children: "Telefone"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((react_input_mask_default()), PersonalData_objectSpread({
            placeholder: "Digite aqui o seu telefone",
            mask: "(99) 99999-9999",
            type: "tel",
            pattern: "\\([0-9]{2}\\)\\s9[0-9]{4}-[0-9]{4}",
            id: "phone"
          }, register('phone'))), ((_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.message) && /*#__PURE__*/(0,jsx_runtime.jsx)(global/* Error */.jj, {
            children: (_errors$phone2 = errors.phone) === null || _errors$phone2 === void 0 ? void 0 : _errors$phone2.message
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubmitButton, {
          type: "submit",
          disabled: loading,
          children: loading ? 'Enviando...' : 'Lista de Espera'
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Terms, {
          children: ["Na qualidade de Usu\xE1rio declaro que li, compreendi e estou de acordo com os", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            href: "https://inscricao.kenzie.com.br/termos-condicoes",
            target: "_blank",
            rel: "noreferrer",
            children: [' ', "Termos de Uso e com a Pol\xEDtica de Privacidade."]
          })]
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/index.tsx










function Home() {
  var searchParams = (0,navigation.useSearchParams)();

  var _useFirstInteractionF = useFirstInteractionFields(),
      setFirstInteractionInCookies = _useFirstInteractionF.setFirstInteractionInCookies;

  if (typeof document !== 'undefined') setFirstInteractionInCookies(searchParams);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Formul\xE1rio de inscri\xE7\xE3o - Kenzie Academy Brasil"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://inscricao.kenzie.com.br/"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Fa\xE7a o Curso de Programa\xE7\xE3o da Kenzie, entre no mercado rapidamente e ganhe altos sal\xE1rios!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: "Fa\xE7a o Curso de Programa\xE7\xE3o da Kenzie, entre no mercado rapidamente e ganhe altos sal\xE1rios!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PersonalData, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      bgColor: "#000"
    })]
  });
}

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1210);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,140,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);